import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { BookableSlot } from './bookable-slot'
import { bookableSlotActions } from './bookable-slot.actions'
import * as fromBookableSlot from './bookable-slot.reducer'
import { BookableSlotService } from './bookable-slot.service'
import { persistentUserRoleActions } from '../role/user-role/persistent-user-role/persistent-user-role.actions'
import { switchMap, take, tap } from 'rxjs/operators'
import { of } from 'rxjs'
import { persistentUserRoleSelectors } from '../role/user-role/persistent-user-role/persistent-user-role.selector'

@Injectable()
export class BookableSlotEffects extends ResourceEffects<BookableSlot> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public bookableSlotService: BookableSlotService
  ) {
    super(
      fromBookableSlot.FEATURE_NAME,
      bookableSlotService,
      bookableSlotActions,
      actions$
    )
  }
  onSetSelectedUserRole = createEffect(
    () =>
      this.actions$.pipe(
        ofType(persistentUserRoleActions.setSelectedUserRole),
        tap((action) => {
          let userRole:any
          this.store.select(persistentUserRoleSelectors.selectSelectedUserRole).pipe(
            take(1)
            ).subscribe((user)=>{
              userRole=user
            })
            userRole&&this.store.dispatch(bookableSlotActions.resetState())})
      ),
    { dispatch: false }
  )
}
